import type { AxiosError } from 'axios';
import { logException } from '../eventsLogger';

export interface ApiError {
  status: number;
  message: string;
  data?: {
    details: {
      error: boolean;
      errorDesc: string;
      eventID: string;
    };
  };
}

// TODO: to use ApiErrorV7 as global error interface after complete v7 migration
export interface ApiErrorV7 {
  status: number;
  message: string;
  data?: {
    errorDesc: string;
    eventID: string;
  };
}

export class CustomApiError extends Error {
  status: number;
  data?: ApiError['data'];

  constructor(message: string, status: number, data?: ApiError['data']) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.data = data;
  }
}

export async function makeRequest<T>(promise: Promise<{ data: T }>): Promise<T> {
  try {
    const response = await promise;
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    const status = axiosError.response?.status || 500;
    const data = axiosError.response?.data as ApiError['data'];
    const message = `Network error: ${axiosError.message}`;
    const customApiError = new CustomApiError(message, status, data);

    logException(customApiError);

    throw customApiError;
  }
}
